import { render, staticRenderFns } from "./form_edit.vue?vue&type=template&id=07bc50a7&scoped=true"
import script from "./form_edit.vue?vue&type=script&lang=js"
export * from "./form_edit.vue?vue&type=script&lang=js"
import style0 from "./form_edit.vue?vue&type=style&index=0&id=07bc50a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc50a7",
  null
  
)

export default component.exports